{
    "image_upload_error": "Resim yüklenemedi. Bu sayfayı yeniden yüklemeyi ve yeniden bir resim seçmeyi deneyin.",
    "search_placeholder": "Fotoğraf ve illüstrasyonları arayın",
    "search": "Bul",
    "photo": "Resim",
    "image_by": "tarafından",
    "free_photos_from": "Ücretsiz stok görseller",
    "uploading": "Yükleme",
    "cancel": "İptal",
    "select": "Seçiniz"
}
